import { RecentReportsIcon } from '@dynamika-shared/ui/icons';
import { twMerge } from 'tailwind-merge';

export const NoEDTF: React.FC = () => {
  return (
    <div
      className={twMerge(
        'flex flex-col items-center justify-center w-full min-h-[400px] gap-[16px] p-4'
      )}
    >
      <RecentReportsIcon className='size-[60px]' />
      <div className='text-center text-spanishGray text-[16px] leading-[24px] font-sans'>
        <h2>
          No <b className='text-chineseBlack'>eDTF</b> configured.
        </h2>
        <p>You may proceed to the next step.</p>
      </div>
    </div>
  );
};
